module.exports = __webpack_public_path__ + "static/EGR_FlashPage_5-6b86f6f6c43bd36dfd97db5d701858da.jpg";